// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-page-component .tags-input-root{border:1px solid #dfe1e4!important;padding:0 0 0 12px!important;-webkit-transition:border .3s ease;transition:border .3s ease}.setting-page-component .tags-input-root:focus,.setting-page-component .tags-input-root:hover{border:1px solid #f87657!important}.setting-page-component .tags-input-root .tags-input input,.setting-page-component .tags-input-root .tags-input input:hover{border:none!important}", ""]);
// Exports
module.exports = exports;
